export const sxStyles = {
    container: {
        margin: ({ spacing }) => spacing(5) + " auto 0 auto",
        boxShadow: "none",
        border: theme => `1px solid ${theme.palette.greyscale[200]}`,
        borderRadius: ({ spacing }) => spacing(1)
    }
};
